var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _rect, _path1, _path10, _path11, _path12, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLightAzureShadowAdmin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 27,
    viewBox: "0 0 33 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.33899 10.678H15.393V5L13.55 7.568L10.077 5L7.26799 7.568L4.33899 5V10.678Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.005 16.6438C7.411 16.6438 5.302 14.5338 5.302 11.9408C5.302 9.34779 7.411 7.23779 10.005 7.23779C12.599 7.23779 14.708 9.34779 14.708 11.9408C14.708 14.5338 12.599 16.6438 10.005 16.6438ZM10.005 8.33979C8.02 8.33979 6.404 9.95579 6.404 11.9408C6.404 13.9258 8.02 15.5408 10.005 15.5408C11.99 15.5408 13.606 13.9258 13.606 11.9408C13.606 9.95579 11.99 8.33979 10.005 8.33979Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.005 16.3938C7.54911 16.3938 5.552 14.3958 5.552 11.9408H5.052C5.052 14.6718 7.2729 16.8938 10.005 16.8938V16.3938ZM5.552 11.9408C5.552 9.48583 7.54911 7.48779 10.005 7.48779V6.98779C7.2729 6.98779 5.052 9.20976 5.052 11.9408H5.552ZM10.005 7.48779C12.4609 7.48779 14.458 9.48583 14.458 11.9408H14.958C14.958 9.20976 12.7371 6.98779 10.005 6.98779V7.48779ZM14.458 11.9408C14.458 14.3958 12.4609 16.3938 10.005 16.3938V16.8938C12.7371 16.8938 14.958 14.6718 14.958 11.9408H14.458ZM10.005 8.08979C7.88193 8.08979 6.154 9.81772 6.154 11.9408H6.654C6.654 10.0939 8.15807 8.58979 10.005 8.58979V8.08979ZM6.154 11.9408C6.154 14.064 7.88202 15.7908 10.005 15.7908V15.2908C8.15798 15.2908 6.654 13.7876 6.654 11.9408H6.154ZM10.005 15.7908C12.128 15.7908 13.856 14.064 13.856 11.9408H13.356C13.356 13.7876 11.852 15.2908 10.005 15.2908V15.7908ZM13.856 11.9408C13.856 9.81772 12.1281 8.08979 10.005 8.08979V8.58979C11.8519 8.58979 13.356 10.0939 13.356 11.9408H13.856Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.33899 10.678H15.393V5L13.55 7.568L10.077 5L7.26799 7.568L4.33899 5V10.678Z",
    stroke: "white",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.007 24.6513C18.967 21.0133 16.758 17.8883 13.614 16.5073C13.264 16.7973 12.877 17.0453 12.462 17.2443C15.589 18.2713 17.861 21.1963 17.904 24.6513H2.105C2.15 21.1963 4.421 18.2713 7.548 17.2443C7.133 17.0453 6.746 16.7973 6.395 16.5073C3.252 17.8883 1.043 21.0133 1.002 24.6513H1V25.7513H19.01V24.6513H19.007Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.007 24.6513C18.967 21.0133 16.758 17.8883 13.614 16.5073C13.264 16.7973 12.877 17.0453 12.462 17.2443C15.589 18.2713 17.861 21.1963 17.904 24.6513H2.105C2.15 21.1963 4.421 18.2713 7.548 17.2443C7.133 17.0453 6.746 16.7973 6.395 16.5073C3.252 17.8883 1.043 21.0133 1.002 24.6513H1V25.7513H19.01V24.6513H19.007Z",
    stroke: "white",
    strokeWidth: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7111 24.6508C23.6701 21.0818 21.5431 18.0058 18.4941 16.5868L18.2521 16.5218C18.0661 16.5158 17.5671 16.2958 16.9191 16.0668C18.3951 15.2718 19.4111 13.7308 19.4111 11.9408C19.4111 9.34779 17.3021 7.23779 14.7081 7.23779C12.1151 7.23779 10.0051 9.34779 10.0051 11.9408C10.0051 13.6298 10.9071 15.1018 12.2481 15.9308C11.9201 16.0778 11.5701 16.2678 11.0981 16.5068C7.95513 17.8888 5.74613 21.0128 5.70513 24.6508H5.70312V25.7508H23.7131V24.6508H23.7111Z",
    fill: "#368FEF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7111 24.6508C23.6701 21.0818 21.5431 18.0058 18.4941 16.5868L18.2521 16.5218C18.0661 16.5158 17.5671 16.2958 16.9191 16.0668C18.3951 15.2718 19.4111 13.7308 19.4111 11.9408C19.4111 9.34779 17.3021 7.23779 14.7081 7.23779C12.1151 7.23779 10.0051 9.34779 10.0051 11.9408C10.0051 13.6298 10.9071 15.1018 12.2481 15.9308C11.9201 16.0778 11.5701 16.2678 11.0981 16.5068C7.95513 17.8888 5.74613 21.0128 5.70513 24.6508H5.70312V25.7508H23.7131V24.6508H23.7111Z",
    stroke: "#368FEF",
    strokeWidth: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.18176 10.678H20.2348V5L18.3928 7.568L14.9188 5L12.1108 7.568L9.18176 5V10.678Z",
    fill: "#368FEF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.18176 10.678H20.2348V5L18.3928 7.568L14.9188 5L12.1108 7.568L9.18176 5V10.678Z",
    stroke: "#368FEF",
    strokeWidth: 0.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.75,
    y: 0.75,
    width: 18.5,
    height: 16.5,
    rx: 1.25,
    fill: "#212A30",
    stroke: "#368FEF",
    strokeWidth: 1.5
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0005 3.00014H24.5514L20.8652 13.9219C20.8273 14.0342 20.7552 14.1317 20.659 14.2008C20.5627 14.2699 20.4473 14.307 20.3288 14.3071H17.5653C17.4756 14.3071 17.3871 14.2857 17.3073 14.2447C17.2274 14.2038 17.1585 14.1444 17.1061 14.0715C17.0538 13.9986 17.0195 13.9143 17.0062 13.8255C16.9929 13.7368 17.001 13.6461 17.0297 13.5611L20.464 3.38526C20.5018 3.27298 20.574 3.17541 20.6702 3.1063C20.7665 3.03719 20.882 3.00001 21.0005 3V3.00014Z",
    fill: "url(#paint0_linear_5070_54)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1605 10.3257H20.5296C20.4772 10.3256 20.4261 10.3413 20.3828 10.3708C20.3395 10.4002 20.3061 10.442 20.2868 10.4907C20.2676 10.5394 20.2635 10.5927 20.2751 10.6438C20.2867 10.6949 20.3133 10.7413 20.3516 10.7769L23.9699 14.1541C24.0752 14.2524 24.2139 14.307 24.358 14.307H27.5464L26.1605 10.3257Z",
    fill: "#0078D4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0007 3C20.8809 2.99954 20.7641 3.0374 20.6674 3.10803C20.5707 3.17867 20.499 3.27839 20.463 3.39263L17.0341 13.5517C17.0035 13.637 16.9939 13.7285 17.0061 13.8183C17.0183 13.9082 17.052 13.9938 17.1043 14.0679C17.1565 14.1419 17.2259 14.2023 17.3065 14.244C17.387 14.2856 17.4764 14.3072 17.5671 14.3069H20.4019C20.5075 14.2881 20.6062 14.2415 20.6879 14.172C20.7696 14.1025 20.8314 14.0126 20.8669 13.9114L21.5507 11.8962L23.9932 14.1744C24.0955 14.259 24.2239 14.3058 24.3568 14.3069H27.5333L26.1401 10.3256L22.0788 10.3266L24.5644 3H21.0007Z",
    fill: "url(#paint1_linear_5070_54)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5358 3.38458C25.498 3.27248 25.426 3.17508 25.3299 3.10608C25.2338 3.03709 25.1185 2.99999 25.0002 3H21.0427C21.161 3.00001 21.2763 3.03712 21.3724 3.10611C21.4685 3.1751 21.5406 3.27249 21.5784 3.38458L25.0128 13.5608C25.0416 13.6459 25.0496 13.7365 25.0363 13.8253C25.023 13.9141 24.9888 13.9984 24.9365 14.0714C24.8841 14.1443 24.8151 14.2037 24.7353 14.2447C24.6554 14.2857 24.5669 14.307 24.4772 14.3071H28.4347C28.5245 14.307 28.613 14.2856 28.6928 14.2446C28.7727 14.2036 28.8416 14.1442 28.8939 14.0713C28.9463 13.9984 28.9805 13.9141 28.9938 13.8253C29.007 13.7365 28.999 13.6459 28.9703 13.5608L25.5358 3.38458Z",
    fill: "url(#paint2_linear_5070_54)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5070_54",
    x1: 22.2947,
    y1: 3.83802,
    x2: 18.607,
    y2: 14.7324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#114A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0669BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5070_54",
    x1: 23.4469,
    y1: 8.91496,
    x2: 22.5938,
    y2: 9.20339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.071,
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.321,
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623,
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5070_54",
    x1: 22.9775,
    y1: 3.52013,
    x2: 27.0255,
    y2: 14.3047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CCBF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2892DF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightAzureShadowAdmin);
export default __webpack_public_path__ + "static/media/light_azure_shadow_admin.8d739cf6dda07ec98521c9fef52cfd77.svg";
export { ForwardRef as ReactComponent };